// import config from "../config/environment";

// const BASE_URL = config.BASE_URL;

// export const apiClient = async (
//     endpoint: string,
//     method: string = "GET",
//     body: any = null
// ) => {
//     const headers: Record<string, string> = {
//         "Content-Type": "application/json",
//     };
//     try {
//         const response = await fetch(`${BASE_URL}${endpoint}`, {
//             method: method,
//             headers: headers,
//             body: JSON.stringify(body),
//         });
//         const contentType = response.headers.get("content-type")
//         return await response.json();
//     } catch (error) {
//         return {
//             success: false,
//             message: "API request failed",
//             data: [],
//         };
//     }
// };

import config from '../config/environment';

const BASE_URL = config.BASE_URL;

export const apiClient = async (endpoint: string, method: string = 'GET', body: any = null) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  /** Convert string back to object */
  const userLoginData = localStorage.getItem('userLoginData');
  if (userLoginData) {
    const parsedUserData = JSON.parse(userLoginData);
    if (parsedUserData?.api_key && parsedUserData?.api_secret) {
      headers['Authorization'] = `token ${parsedUserData?.api_key}:${parsedUserData?.api_secret}`;
    }
  }
  // Prepare fetch options
  const options: RequestInit = {
    method,
    headers,
    // credentials: "include",
  };

  /** Only include body for non-GET/HEAD requests */
  if (body && method !== 'GET' && method !== 'HEAD') {
    options.body = JSON.stringify(body);
  }
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, options);
    // console.log(response);
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    } else {
      return await response.text();
    }
  } catch (error) {
    // console.log(error);
    return {
      success: false,
      message: 'API request failed',
      data: [],
    };
  }
};
